import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/LangSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Navbar.tsx");
